import {
  ChangeDetectionStrategy,
  Component,
  input, output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MotifModule } from '@ey-xd/ng-motif';
import { Option } from '@models/pagination-select-option';

@Component({
  selector: 'app-pagination-select',
  standalone: true,
  imports: [MotifModule, FormsModule, ReactiveFormsModule],
  templateUrl: './pagination-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationSelectComponent {
  label = input.required<string>();
  selectedOption = input.required<Option>();
  options = input.required<Option[]>();
  selectionChange = output<Option>();

  sortComparator = (a: Option, b: Option) =>
    (a.id as number) - (b.id as number);

  public onSelectionChange(optionId: number): void {
    const sortedOptions = this.options().sort(
      (a: Option, b: Option) => (a.id as number) - (b.id as number)
    );
    const emitSelectedOption = sortedOptions.find(
      (o: Option) => o.id === optionId
    );
    if (emitSelectedOption) {
      this.selectionChange.emit(emitSelectedOption);
    }
  }

  protected getOptionLabel(option: Option): string {
    return this.label().concat('\xA0').concat(option.name);
  }
}
